import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { GALRecipientWellModal } from 'owa-global-address-list-recipient-well-modal';
import { IButton, IconButton } from '@fluentui/react/lib/Button';
import * as React from 'react';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import RecipientType from 'owa-recipient-types/lib/types/RecipientType';
import { RecipientWellLabel } from 'owa-recipient-well-label/lib/components/RecipientWellLabel';
import { convertRecipientsToAttendees } from 'owa-calendar-notes-editor/lib/utils/recipientAttendeeConversions';
import { getReadWriteRecipientViewStateFromFindRecipientPersonaType } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromFindRecipientPersonaType';
import { observer } from 'mobx-react-lite';
import { useBooleanState } from 'owa-react-hooks/lib/useBooleanState';

export interface IconWithGALForCalendarProps {
    icon: string;
    ariaLabel: string;
    recipientType: RecipientType;
    updateAttendees: (attendees: AttendeeType[]) => void;
    recipients: ReadWriteRecipientViewState[];
}

const IconWithGALForCalendar: React.FunctionComponent<IconWithGALForCalendarProps> = props => {
    const { icon, ariaLabel, recipientType, updateAttendees, recipients } = props;

    const [isGalModalOpen, openGalModal, closeGalModal] = useBooleanState(false);

    const galButtonRef = React.useRef<IButton>();
    const onDismissGal = React.useCallback(() => {
        closeGalModal();
        galButtonRef?.current?.focus();
    }, [galButtonRef?.current]);
    const setGALButtonRef = (button: IButton) => {
        galButtonRef.current = button;
    };

    const galOnItemAdded = (persona: FindRecipientPersonaType) => {
        const recipient: ReadWriteRecipientViewState = getReadWriteRecipientViewStateFromFindRecipientPersonaType(
            persona
        );
        recipients.push(recipient);
        updateAttendees(convertRecipientsToAttendees(recipients));
    };

    const galOnItemChange = (
        replaceRecipient: ReadWriteRecipientViewState | ReadWriteRecipientViewState[],
        index: number
    ) => {
        replaceRecipient = (replaceRecipient instanceof Array
            ? replaceRecipient
            : replaceRecipient
            ? [replaceRecipient]
            : []) as ReadWriteRecipientViewState[];
        recipients.splice(index, 1, ...replaceRecipient);
        updateAttendees(convertRecipientsToAttendees(recipients));
    };

    return (
        <>
            <IconButton
                componentRef={setGALButtonRef}
                title={ariaLabel}
                iconProps={{ iconName: icon }}
                onClick={openGalModal}
                ariaLabel={ariaLabel}
            />
            {isGalModalOpen && (
                <GALRecipientWellModal
                    wellLabel={<RecipientWellLabel recipientType={recipientType} />}
                    onItemAdded={galOnItemAdded}
                    onItemChange={galOnItemChange}
                    onDismiss={onDismissGal}
                    recipients={recipients}
                />
            )}
        </>
    );
};

export default observer(IconWithGALForCalendar);
